import React from "react";

import { useDisciplinesSettings } from "./hooks/useDisciplinesSettings";

import DisciplinesHeader from "./components/DisciplinesHeader";
import DisciplinesKpiCards from "./components/DisciplinesKpiCards";
import DisciplinesFiltersCard from "./components/DisciplinesFiltersCard";
import DisciplinesTable from "./components/DisciplinesTable";
import DisciplineFormDrawer from "./components/DisciplineFormDrawer";

export default function SettingsDisciplines() {
  const dashboard = useDisciplinesSettings();

  return (
    <div className="space-y-5">
      <DisciplinesHeader onCreate={dashboard.openCreateDrawer} />

      <DisciplinesKpiCards
        stats={dashboard.stats}
        filteredStats={dashboard.filteredStats}
        loading={dashboard.loading}
      />

      <DisciplinesFiltersCard
        filters={dashboard.filters}
        setFilter={dashboard.setFilter}
        resetFilters={dashboard.resetFilters}
        filteredCount={dashboard.filteredDisciplines.length}
        totalCount={dashboard.disciplines.length}
        loading={dashboard.loading}
        onRefresh={dashboard.fetchDisciplines}
      />

      <DisciplinesTable
        disciplines={dashboard.filteredDisciplines}
        loading={dashboard.loading}
        deletingId={dashboard.deletingId}
        reordering={dashboard.reordering}
        onEdit={dashboard.openEditDrawer}
        onDelete={dashboard.handleDeleteDiscipline}
        onMoveUp={(discipline) =>
          dashboard.moveDiscipline(discipline.id, "up")
        }
        onMoveDown={(discipline) =>
          dashboard.moveDiscipline(discipline.id, "down")
        }
      />

      <DisciplineFormDrawer
        isOpen={dashboard.formDrawerOpen}
        mode={dashboard.formMode}
        discipline={dashboard.editableDiscipline}
        nextOrder={dashboard.nextOrder}
        submitting={dashboard.submittingForm}
        uploadProgress={dashboard.uploadProgress}
        onClose={dashboard.closeFormDrawer}
        onSubmit={dashboard.handleSubmitDiscipline}
      />
    </div>
  );
}